<template>
  <div class="index-feed-tab" :style="{ top: stickyTop }">
    <scroll-view class="feed-tab-scroll" scroll-x>
      <!-- 单个tab -->
      <div
        v-for="(tab, index) in class1List"
        :id="`index-feed-tab-${tab.class1Id}`"
        :key="index"
        :class="[
          'home-feed-header-tab-item',
          tab.class1Id === class1Id ? 'tab-item-active' : ''
        ]"
        @click="bindClickTab(tab, index)"
      >
        {{ tab.name }}
        <img v-if="tab.promotePic" class="tab-label" :src="tab.promotePic" />
      </div>
    </scroll-view>
    <class2-list
      v-if="class2List.length"
      :class2-list="class2List"
      :class2-id="class2Id"
      :class1-id="class1Id"
      @selectClass2="selectClass2"
    ></class2-list>
  </div>
</template>

<script>
import ScrollView from '@/common/widget/ScrollView/index.vue'
import { miniProgramEnv } from '@/defines/environment'

import Class2List from './components/Class2List.vue'

export default {
  components: {
    ScrollView,
    Class2List
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['class1List', 'class2List', 'class1Id', 'class2Id'],
  data() {
    return {}
  },
  computed: {
    stickyTop() {
      if (miniProgramEnv.isMiniProgram) return '0px'
      return this.statusBarHeight + 44 + 'px'
    }
  },
  methods: {
    // 点击feed Tab
    bindClickTab(tab, index) {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('onClass1Change', {
        tab,
        index
      })
      const tabDom = document.querySelector(`#index-feed-tab-${tab.class1Id}`)
      tabDom.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      })
    },
    selectClass2(item) {
      this.$emit('selectClass2', item)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.feed-tab-scroll {
  writing-mode: initial !important;
  @include flex(row, flex-start, flex-start, nowrap);
}

.index-feed-tab {
  position: -webkit-sticky;
  position: sticky;
  z-index: 999 !important;
  top: 0px;
  width: 100%;
  max-width: 668px;
  background: #ffffff;
  margin: 0 auto;
}

.label-container {
  display: flex;
}
.home-feed-header-tab-item {
  flex-shrink: 0;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  color: #262626;
  font-size: 16px;
  z-index: 1;
  position: relative;
  z-index: 999;
  &.tab-item-active {
    position: relative;
    z-index: 999;
    font-weight: 500;
    font-size: 16px;
    color: #f03100;
    &::after {
      display: block;
      width: 20px;
      height: 3px;
      background: #f03100;
      border-radius: 2px;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      content: '';
      z-index: -1;
    }
  }

  .tab-label {
    position: absolute;
    width: 28px;
    height: 14px;
    right: 2px;
    top: 4px;
  }
}
</style>
